import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';

export const getWarrantyStatus = createAsyncThunk('manufacturerWarrantyStatus/getManufacturerWarrantyStatus', async (data, thunkAPI) => {
    try {
        thunkAPI.dispatch(showAppLoader());
        const result = await ProviderManager.getProviderData('getWarrantyStatus', [data.serialNumber, "I"]);
        return { isSuccess: true, data: result.Body };
    } catch (error) {
        return { isSuccess: false, data: null };
    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
});


const initialState = {
    cmsData: null,
    serialNumber: "",
    result: {
        display: false,
        isCellcomEquipment: false,
        isSuccess: false,
        svcStatus: "",
        errorDescription: "",
        warrantyStatus: "",
        warrantyDate: ""
    }

};

const manufacturerWarrantyStatusBlockSlice = createSlice({
    name: 'manufacturerWarrantyStatus',
    initialState: initialState,
    reducers: {
        resetBlock: (state) => initialState,
        initBlock: {
            reducer: (state, action) => {
                state.cmsData = action.payload.manufacturerWarrantyStatusBlockData;
                state.serialNumber = "";
                state.result = {
                    display: false,
                    isCellcomEquipment: false,
                    svcStatus: "",
                    errorDescription: "",
                    warrantyStatus: "",
                    warrantyDate: ""
                }
            },
            prepare: (action) => {
                let payload = {};
                payload.cmsData = action.manufacturerWarrantyStatusBlockData;
                return { payload: payload };
            },
        },
        clearResult: (state, action) => {
            state.result = {
                display: false,
                isCellcomEquipment: false,
                svcStatus: "",
                errorDescription: "",
                warrantyStatus: "",
                warrantyDate: ""
            }
        },
        reportDWH: (state, action) => {
        },
    },
    extraReducers: {
        [getWarrantyStatus.fulfilled]: (state, action) => {
            if (!action.payload.isSuccess) {
                state.result.display = true;
                state.result.isSuccess = false;
                return;
            }
            state.result = {
                display: true,
                isSuccess: true,
                isCellcomEquipment: action.payload.data.isCellcomEquipment,
                svcStatus: action.payload.data.svcStatus,
                errorDescription: action.payload.data.errorDescription,
                warrantyStatus: action.payload.data.warrInd,
                warrantyDate: action.payload.data.warrEndDate
            }
        },
    },
});

export const {
    resetBlock,
    initBlock,
    clearResult,
    reportDWH
} = manufacturerWarrantyStatusBlockSlice.actions;

export default manufacturerWarrantyStatusBlockSlice.reducer;
